// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, Input } from '@angular/core';

@Component({
  standalone: true,
  imports: [CommonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  selector: 'app-cts-gantry-functional-unit-step-labels',
  templateUrl: './cts-gantry-functional-unit-step-labels.component.html',
  styleUrl: './cts-gantry-functional-unit-step-labels.component.scss',
})
export class CtsGantryFunctionalUnitStepLabelsComponent {
  @Input({ required: true }) labels: string[] = [];
}
